import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./css/layout.css";
import "./css/base.css";
import passportBg from "./images/passport.png";
import "./css/skeleton.css";
import Gallery from "./components/Slideshow";
import getAllEvents from "./api/events/getAllEvents";
import Partners from "./components/partners";
import contactUs from "./api/contactus/contactUs";
import { getAnalytics, logEvent } from "firebase/analytics";
import AppBar from "./components/AppBar";
import Footer from "./components/Footer";

function Dashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const menuRef = useRef();
  const navbarRef = useRef();
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [scrolling, setScrolling] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [scrollTrigger, setScrollTrigger] = useState("");
  const [events, setEvents] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    info: "",
    type: "",
  });
  const [partnerDialogOpen, setPartnerDialogOpen] = useState(false);
  const [partnerFormData, setPartnerFormData] = useState({
    name: "",
    email: "",
    purpose: "",
  });

  const analytics = getAnalytics();
  logEvent(analytics, "screen_view", {
    firebase_screen: "DASHBOARD",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    try {
      await contactUs(formData).then((_) => {
        alert("Thank you for contacting us!");
      }); // Call postEventData function with formData
      setFormData({
        name: "",
        email: "",
        info: "",
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form. Please try again later.");
    }
  };

  const handlePartnerChange = (e) => {
    const { name, value } = e.target;
    setPartnerFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePartnerSubmit = async (e) => {
    e.preventDefault();
    try {
      // You can use the same contactUs API or create a new one for partners
      await contactUs({
        name: partnerFormData.name,
        email: partnerFormData.email,
        info: `${partnerFormData.purpose}`,
        type: "partner",
      }).then((_) => {
        alert("Thank you for your partnership interest! We'll get back to you soon.");
        setPartnerDialogOpen(false);
        setPartnerFormData({
          name: "",
          email: "",
          purpose: "",
        });
      });
    } catch (error) {
      console.error("Error submitting partner form:", error);
      alert("Error submitting form. Please try again later.");
    }
  };

  useEffect(() => {
    const handleResize = () => setScreenHeight(window.innerHeight);
    const handleResizew = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    window.addEventListener("resize", handleResizew);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResizew);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    getAllEvents().then((events) => {
      setEvents(events);
      const handleScroll = () => {
        if (window.scrollY > 0) {
          setScrolling(true);
        } else {
          setScrolling(false);
        }
      };

      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    });
  }, []);


  useEffect(() => {
    const element = document.getElementById(scrollTrigger);
    const appBarHeight = document.getElementById("menu-wrap").offsetHeight;

    if (scrollTrigger == "top") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    if (element) {
      const offset = element.offsetTop - appBarHeight;
      window.scrollTo({
        top: offset,
        behavior: "smooth",
      });
    }
    setScrollTrigger("");
  }, [scrollTrigger]);

  // Handle navigation from footer
  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      // Small delay to ensure the page is fully loaded
      setTimeout(() => {
        setScrollTrigger(location.state.scrollTo);
      }, 100);
    }
  }, [location.state]);



  return (
    <div>
      {screenWidth > 768 && (
        <div className="top-flair">
          <div className="flair-cont">
            <p className="flair-content">
              <strong style={{ letterSpacing: "0.1em" }}>
                {/* Be Among the First to Preview the 2025 Race Lineup!{" "} */}
                Aquaman Somabay is sold out!
              </strong>
            </p>
            {/* <button
              onClick={() => setScrollTrigger("races")}
              className="flair-btn"
            >
              Discover Now
            </button> */}
          </div>
        </div>
      )}
      <AppBar 
        scrolling={scrolling} 
        showPartnerButton={screenWidth > 768}
        onPartnerClick={() => setPartnerDialogOpen(true)}
      />
      <div className="cd-main">
        <div className="section" id="home">
          <div className="hero-top">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div>
                <p className="container-top-main" style={{ fontSize: "40px !important" }}>
                  AQUAMAN OPEN WATER SWIMMING
                </p>
              </div>
            </div>
          </div>
          <div
            style={{
              height: "630px",
              width: "100%",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <img
              src="https://firebasestorage.googleapis.com/v0/b/aquaman-5b7b3.appspot.com/o/Aquaman%20Website%202025%20(1).webp?alt=media&token=84eb6f14-edb3-42ab-ba14-540cc6292ba4"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                border: "none",
              }}
              alt="First Fold Background"
            />
          </div>
        </div>
      </div>
      <div className="dashboard-sponsors">
        <p
          className="smaller"
          style={{
            color: "white",
            textAlign: "center",
            fontFamily: "Poppins",
            fontStyle: "italic",
            fontSize: "16px",
            fontWeight: 900,
          }}
        >
          POWERED BY BOOST
        </p>
        <p
          className="smaller"
          style={{
            color: "white",
            textAlign: "center",
            fontFamily: "Poppins",
            fontWeight: 600,
            fontSize: "16px",
            marginTop: "4px",
          }}
        >
          join the{" "}
          <span
            className="smaller"
            style={{
              color: "#D69B29",
              textAlign: "center",
              fontFamily: "Poppins",
              fontWeight: 600,
              fontSize: "20px",
              marginTop: "4px",
            }}
          >
            50+
          </span>{" "}
          Partners that made Aquaman happen
        </p>
        <br></br>
        <Partners />
      </div>
      <div id="races">
        <div className="section" style={{}}>
          <div className="container">
            <div className="twelve columns">
              <div
                className="header-text main-pages"
                style={{ marginTop: "50px" }}
              >
                <span
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: 900,
                    fontSize: "54px",
                    color: "#112348",
                    lineHeight: "1.1",
                  }}
                >
                  2025 Races
                </span>
                <div
                  style={{
                    fontWeight: 400,
                    fontSize: "20px",
                    fontFamily: "Poppins",
                    color: "#112348",
                    marginTop: "24px",
                    textAlign: "center",
                    lineHeight: "1.2", // Adjust this value as needed
                  }}
                >
                  Discover Your Dream Swim Race and dive into Aquaman's
                  Selection Below!
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {window.innerWidth < 1200 ? (
          <div>
            {events.filter(event => event.onDisplay == true).map((event, index) => (
              <img
                key={index}
                src={event.imageUrl}
                alt={`Image ${index + 1}`}
                style={{ width: "100%", cursor: "pointer" }}
                onClick={(_) => {
                  // if(event.isActive){
                  navigate(`/event/${event._id}`);
                  // }
                }}
              />
            ))}
          </div>
        ) : (
          <Gallery
            imageUrls={events.filter(event => event.onDisplay == true).map((event) => event.imageUrl)}
            ids={events.filter(event => event.onDisplay == true).map((event) => event._id)}
            isActives={events.filter(event => event.onDisplay == true).map((event) => true)}
          />
        )}
      </div>
      {/* <div className="slider-container">
        <div className="arrow arrow-left" onClick={() => {}}>&#10094;</div>
        <div className="slider">
          <div className="slide"><img src="https://domf5oio6qrcr.cloudfront.net/medialibrary/9833/GettyImages-526245433.jpg" alt="Image 1" /></div>
          <div className="slide"><img src="https://domf5oio6qrcr.cloudfront.net/medialibrary/9833/GettyImages-526245433.jpg" alt="Image 2" /></div>
          <div className="slide"><img src="https://domf5oio6qrcr.cloudfront.net/medialibrary/9833/GettyImages-526245433.jpg" alt="Image 3" /></div>
          <div className="slide"><img src="https://domf5oio6qrcr.cloudfront.net/medialibrary/9833/GettyImages-526245433.jpg" alt="Image 3" /></div>
          <div className="slide"><img src="https://domf5oio6qrcr.cloudfront.net/medialibrary/9833/GettyImages-526245433.jpg" alt="Image 3" /></div>
        </div>
        <div className="arrow arrow-right" onClick={() => {}}>&#10095;</div>
      </div> */}

      <div className="clear"></div>

      <div id="why">
        <div className="whyaquaman">
          <div className="whyaquaman-left">
            <img
              src="https://makanakboost.s3.eu-central-1.amazonaws.com/aquaman/backgrounds/AM_Homepage_About-05.png"
              class="whyaquaman-left-image"
              alt="Your Image"
            />
          </div>

          <div className="whyaquaman-right">
            <p
              style={{
                fontFamily: "Poppins",
                fontWeight: 700,
                color: "#D69B29",
                fontSize: "10px",
              }}
            >
              ABOUT US
            </p>
            <br />
            <p
              style={{
                fontFamily: "Poppins",
                fontWeight: 700,
                color: "#112348",
                fontSize: "40px",
              }}
            >
              Why Aquaman
            </p>
            <br />
            <p
              style={{
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "#112348",
                fontSize: "16px",
              }}
            >
              At Aquaman, we're your go to for open water swimming competitions.
              Partnered with Boost for top-notch event hosting, we offer six
              races suited for all levels: Aquaman 10km, Aquaman 5.0 5km,
              Aquaman 2.0 2km, Aquakids 500m, Aquateams 3X500m, and Aquafins
              1km. Dive into the excitement, whether you're a seasoned pro or
              just starting out. Start your swimming journey with us today!
            </p>
          </div>
        </div>

        <div
          class="section padding-top-bottom-smaller"
          style={{ backgroundColor: "#112348" }}
        >
          <div class="container flex-column" style={{ display: "flex" }}>
            <div class="twelve columns">
              <div class="counter-wrap">
                <div class="counter-numb">
                  <em
                    class="counter-facts"
                    style={{ color: "#00EEFF", fontWeight: "900" }}
                  >
                    60+
                  </em>
                </div>
                <p style={{ fontSize: "12px", letterSpacing: "1px" }}>
                  Countries participate in our event{" "}
                  {window.innerWidth > 780 && <br />} each year
                </p>
              </div>
            </div>
            <div class="twelve columns">
              <div class="counter-wrap">
                <div class="counter-numb">
                  <em
                    class="counter-facts"
                    style={{ color: "#00EEFF", fontWeight: "bold" }}
                  >
                    25,000+
                  </em>
                </div>
                <p style={{ fontSize: "12px", letterSpacing: "1px" }}>
                  Swimmers participate in events and our swim in our academies
                </p>
              </div>
            </div>
            <div class="twelve columns">
              <div class="counter-wrap">
                <div class="counter-numb">
                  <em
                    class="counter-facts"
                    style={{ color: "#00EEFF", fontWeight: "bold" }}
                  >
                    25+
                  </em>
                </div>
                <p style={{ fontSize: "12px", letterSpacing: "1px" }}>
                  partners in success around {window.innerWidth > 780 && <br />}{" "}
                  the world
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="clear"></div>
      <div id="passport">
        <div
          style={{
            position: "relative",
            backgroundImage: `url(${passportBg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            borderRadius: "12px",
            overflow: "hidden",
            margin: "0 auto",
            marginTop: "30px",
            padding: "2em 8em",
            width: "88vw",
            maxWidth: "1200px",
            minHeight: "560px",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "40px",
              transform: "translateY(-50%)",
              color: "#112348",
              background: "transparent",
              padding: 0,
              borderRadius: 0,
              maxWidth: "620px",
            }}
          >
            <div
              style={{
                fontFamily: "Poppins",
                fontWeight: 900,
                fontSize: "56px",
                lineHeight: 0.95,
                letterSpacing: "2px",
                marginBottom: "18px",
                textTransform: "uppercase",
              }}
            >
              AQUAMAN<br />PASSPORT
            </div>
            <div
              style={{
                fontFamily: "Poppins",
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: 1.6,
                color: "#112348",
                marginBottom: "18px",
                maxWidth: "560px",
              }}
            >
              Your journey doesn’t end at the finish line. With the Aquaman Passport every
              race you swim earns you points, rewards, and a place on our global
              leaderboard. Track your progress, climb the rankings, and unlock exclusive
              benefits as part of our loyalty program—designed to celebrate your passion
              for open water swimming.
            </div>
            <button
              onClick={() => navigate('/passport')}
              style={{
                backgroundColor: "#D69B29",
                color: "#ffffff",
                border: "none",
                padding: "10px 14px",
                borderRadius: "6px",
                fontFamily: "Poppins",
                fontWeight: 600,
                fontSize: "12px",
                cursor: "pointer",
                display: "inline-block",
                textAlign: "left",
                width: "fit-content",
              }}
            >
              View my passport
            </button>
          </div>
        </div>
      </div>
      <div className="clear"></div>
      <div id="store">
        <div class="section">
          <div class="container">
            <div class="twelve columns">
              <div class="header-text main-pages" style={{ marginTop: "50px" }}>
                <span
                  style={{
                    color: "#112348",
                    fontSize: "48px",
                    fontFamily: "Poppins",
                    fontWeight: "900",
                    lineHeight: "1.1",
                  }}
                >
                  Aquaman's Store
                </span>
                <div
                  style={{
                    fontWeight: 400,
                    fontSize: "20px",
                    fontFamily: "Poppins",
                    color: "#112348",
                    marginTop: "32px",
                    textAlign: "center",
                    lineHeight: "1.2", // Adjust this value as needed
                  }}
                >
                  Discover Your Dream Swim Race and dive into Aquaman's
                  Selection Below!
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="clear"></div>
      <div>
        <div class="section  padding-top-bottom-smaller">
          {/* <div class="parallax-3"></div> */}
          <div
            class="container"
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "0 32px",
              maxWidth: "100%",
              height: "auto",
            }}
          >
            <img
              style={{ height: "auto", maxWidth: "400px", padding: "0 16px" }}
              src="https://firebasestorage.googleapis.com/v0/b/aquaman-5b7b3.appspot.com/o/Aquaman%20store%2FProduct%201.svg?alt=media&token=5f0a0d48-c797-4f7a-aea1-9d3417542500"
            ></img>

            <img
              className="hide-mobile"
              style={{ height: "auto", maxWidth: "400px", padding: "0 16px" }}
              src="https://firebasestorage.googleapis.com/v0/b/aquaman-5b7b3.appspot.com/o/Aquaman%20store%2FProduct%202.svg?alt=media&token=42c008ca-3a7c-4adc-af82-f192a95cc0f1"
            ></img>
            <img
              className="hide-mobile-two"
              style={{ height: "auto", maxWidth: "400px", padding: "0 16px" }}
              src="https://firebasestorage.googleapis.com/v0/b/aquaman-5b7b3.appspot.com/o/Aquaman%20store%2FProduct%203.svg?alt=media&token=9fb8be28-3d8a-4abd-8c45-c5fb00d8fe79"
            ></img>
          </div>
          <div>
            <div
              data-lang="en"
              style={{
                backgroundColor: "#D69B29",
                fontFamily: "Poppins",
                color: "white",
                fontSize: "16px",
                fontWeight: 600,
                borderRadius: "4px",
                padding: "12px 16px",
                textAlign: "center",
                overflow: "hidden",
                whiteSpace: "nowrap",
                width: "fit-content",
                margin: "16px auto",
              }}
            >
              Shop Now ..Coming soon
            </div>
          </div>
        </div>
      </div>
      <div className="clear"></div>

      <div id="blog" class="contactus-container">
        <span
          style={{
            fontFamily: "Poppins",
            fontWeight: 600,
            color: "#112348",
            fontSize: "36px",
            lineHeight: "1.1",
            textAlign: "center",
          }}
        >
          Get in Touch with Aquaman
        </span>
        <div
          style={{
            fontFamily: "Poppins",
            fontWeight: 400,
            color: "#112348",
            fontSize: "20px",
            marginTop: "32px",
            textAlign: "center",
          }}
        >
          We're here to answer any questions you have.
        </div>
      </div>
      <form
        name="ajax-form"
        id="ajax-form"
        onSubmit={handleSubmit}
        method="post"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div data-scroll-reveal="enter bottom move 100px over 0.4s after 0.2s">
            <label for="name">
              <span class="error" id="err-name">
                please enter name
              </span>
            </label>
            <input
              name="name"
              id="name"
              type="text"
              placeholder="Your Name: *"
              onChange={handleChange}
            />
          </div>
          <div data-scroll-reveal="enter bottom move 100px over 0.4s after 0.2s">
            <label for="email">
              <span class="error" id="err-email">
                please enter e-mail
              </span>
              <span class="error" id="err-emailvld">
                e-mail is not a valid format
              </span>
            </label>
            <input
              name="email"
              id="email"
              type="text"
              placeholder="E-Mail: *"
              onChange={handleChange}
            />
          </div>
        </div>
        <div
          class="twelve columns"
          data-scroll-reveal="enter bottom move 100px over 0.4s after 0.2s"
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label for="info"></label>
            <textarea
              name="info"
              id="info"
              placeholder="Tell Us Everything"
              onChange={handleChange}
            ></textarea>
          </div>
        </div>
        <div
          class="twelve columns"
          data-scroll-reveal="enter bottom move 100px over 0.4s after 0.2s"
        >
          <div>
            <button class="contactus-button" data-lang="en">
              Submit
            </button>
          </div>
        </div>
        <div class="clear"></div>
        <div class="error text-align-center" id="err-form">
          There was a problem validating the form please check!
        </div>
        <div class="error text-align-center" id="err-timedout">
          The connection to the server timed out!
        </div>
        <div class="error" id="err-state"></div>
      </form>

      <div className="clear"></div>

      {/* Partner Dialog */}
      {partnerDialogOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={() => setPartnerDialogOpen(false)}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "10px",
              maxWidth: "500px",
              width: "90%",
              boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h4 style={{ margin: 0, color: "#333", fontSize: "18px" }}>
                Become a Partner
              </h4>
              <button
                onClick={() => setPartnerDialogOpen(false)}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#666",
                  padding: "0",
                  lineHeight: "1",
                  width: "20px",
                }}
              >
                ×
              </button>
            </div>
            
            <form onSubmit={handlePartnerSubmit}>
              <div style={{ display: "flex", gap: "15px", marginBottom: "15px" }}>
                <div style={{ flex: 1 }}>
                  <label style={{ 
                    display: "block", 
                    marginBottom: "5px", 
                    fontWeight: "600",
                    color: "#333",
                    fontSize: "13px"
                  }}>
                    Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={partnerFormData.name}
                    onChange={handlePartnerChange}
                    required
                    style={{
                      width: "100%",
                      padding: "10px",
                      border: "1px solid #ddd",
                      borderRadius: "5px",
                      fontSize: "13px",
                      boxSizing: "border-box",
                    }}
                    placeholder="Enter your name"
                  />
                </div>
                
                <div style={{ flex: 1 }}>
                  <label style={{ 
                    display: "block", 
                    marginBottom: "5px", 
                    fontWeight: "600",
                    color: "#333",
                    fontSize: "13px"
                  }}>
                    Email *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={partnerFormData.email}
                    onChange={handlePartnerChange}
                    required
                    style={{
                      width: "100%",
                      padding: "10px",
                      border: "1px solid #ddd",
                      borderRadius: "5px",
                      fontSize: "13px",
                      boxSizing: "border-box",
                    }}
                    placeholder="Enter your email"
                  />
                </div>
              </div>
              
              <div style={{ marginBottom: "20px" }}>
                <label style={{ 
                  display: "block", 
                  marginBottom: "5px", 
                  fontWeight: "600",
                  color: "#333",
                  fontSize: "13px"
                }}>
                  Purpose *
                </label>
                <select
                  name="purpose"
                  value={partnerFormData.purpose}
                  onChange={handlePartnerChange}
                  required
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                    fontSize: "13px",
                    backgroundColor: "white",
                    boxSizing: "border-box",
                  }}
                >
                  <option value="">Select a purpose</option>
                  <option value="Event Sponsorship">Event Sponsorship</option>
                  <option value="Brand Partnership">Brand Partnership</option>
                  <option value="Marketing Collaboration">Marketing Collaboration</option>
                  <option value="Product Partnership">Product Partnership</option>
                  <option value="Community Outreach">Community Outreach</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              
              <div style={{ display: "flex", gap: "15px" }}>
                <button
                  type="submit"
                  style={{
                    flex: 1,
                    padding: "10px 20px",
                    backgroundColor: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    fontSize: "13px",
                    cursor: "pointer",
                    fontWeight: "600",
                  }}
                >
                  Submit
                </button>
                <button
                  type="button"
                  onClick={() => setPartnerDialogOpen(false)}
                  style={{
                    flex: 1,
                    padding: "10px 20px",
                    backgroundColor: "#6c757d",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    fontSize: "13px",
                    cursor: "pointer",
                    fontWeight: "600",
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
}

export default Dashboard;
